﻿import {$$, hide, show} from "@/Utils"

export function initFileUpload() {

    const fileUploadDiv = document.querySelector('.file-upload') as HTMLDivElement;

    if (!fileUploadDiv) return;

    const uploadBtnDiv = fileUploadDiv?.querySelector('.upload-button-wrapper') as HTMLDivElement;
    const titleDiv = fileUploadDiv?.querySelector('.title') as HTMLDivElement;
    const titleOrArea = titleDiv?.querySelector('.title-or-area') as HTMLDivElement;
    const filenameContainerDiv = fileUploadDiv?.querySelector('.filename_container') as HTMLDivElement;
    const filenameDiv = filenameContainerDiv?.querySelector('.filename') as HTMLDivElement;
    const removeFile = fileUploadDiv?.querySelector('.remove-file') as HTMLSpanElement;
    const descriptionDiv = fileUploadDiv?.querySelector('.description') as HTMLDivElement;

    const fileUploadMessageDiv = fileUploadDiv?.querySelector('.message') as HTMLDivElement;
    const successSpan = fileUploadMessageDiv?.querySelector('.success') as HTMLSpanElement;
    const errorSpan = fileUploadMessageDiv?.querySelector('.error') as HTMLSpanElement;
    const errorSizeSpan = fileUploadMessageDiv?.querySelector('.error_size') as HTMLSpanElement;
    const errorExtSpan = fileUploadMessageDiv?.querySelector('.error_extension') as HTMLSpanElement;
    const errorRetrySpan = fileUploadMessageDiv?.querySelector('.error_retry') as HTMLSpanElement;

    const maxFileSize = 10 * 1024 * 1024;
    const fileInput = document.getElementById('CvFile') as HTMLInputElement;
    if (fileInput) {
        fileInput.type = 'file';
        fileInput.accept = '.pdf,.doc,.docx';
    }

    resetDivVisibility(true);

    // Prevent defaults on Drag and Drop events
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
        fileUploadDiv.addEventListener(eventName, preventDefaults, false);
    });

    // Handle dropped files
    fileUploadDiv.addEventListener('drop', (e: DragEvent) => {
        const dt = e.dataTransfer;
        if (dt?.files) {
            handleFiles(dt.files);
        }
    });

    // Handle click upload
    const uploadButton = fileUploadDiv.querySelector('.button--file-upload') as HTMLButtonElement;
    uploadButton.addDataBoundEventListener('click', () => {
        fileInput.click();
    });

    fileInput.addDataBoundEventListener('change', (e) => {
        const target = e.target as HTMLInputElement;
        if (target.files && target.files.length > 0) {
            handleFiles(target.files);
        } else {
            removeFile.click();
        }
    });

    // Add click handler for delete icon
    removeFile?.addEventListener('click', () => {
        fileInput.value = '';

        resetDivVisibility(true);
        // Show upload button again
        show(uploadBtnDiv);
        show(titleOrArea);
    });

    function handleFiles(files: FileList) {
        if (files.length > 0) {

            resetDivVisibility();

            const file = files[0];
            // Check file type
            if (!file.type.match('application/pdf|application/msword|application/vnd.openxmlformats-officedocument.wordprocessingml.document')) {

                show(fileUploadMessageDiv);
                show(errorSpan);
                show(errorExtSpan);
                show(errorRetrySpan);

                return;
            }

            if (file.size > maxFileSize) {

                show(fileUploadMessageDiv);
                show(errorSpan);
                show(errorSizeSpan);
                show(errorRetrySpan);

                return;
            }

            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(file);
            fileInput.files = dataTransfer.files;
            filenameDiv.textContent = file.name;

            show(filenameContainerDiv);
            show(fileUploadMessageDiv);
            show(successSpan);

            hide(uploadBtnDiv);
            hide(titleOrArea);
        }
    }

    function resetDivVisibility(isInitialLoad: boolean = false) {
        hide(filenameContainerDiv);
        hide(fileUploadMessageDiv);
        hide(successSpan);
        hide(errorSpan);
        hide(errorSizeSpan);
        hide(errorExtSpan);
        hide(errorRetrySpan);

        if (isInitialLoad) {
            show(descriptionDiv);
        } else {
            hide(descriptionDiv);
        }
    }

    function preventDefaults(e: Event) {
        e.preventDefault();
        e.stopPropagation();
    }
}